export const redirectTo = {
  "KYC Verification": "/KYCVerification",
  "Profile": "/Profile",
  "Personal Details": "/Profile",
  "Address Details": "/AddressDetails",
  "Nominee Details": "/NomineeDetails",
  "Bank Details": "/BankDetails",
  "Plan Details": "/PlanDetails",
  "Upload & Submit": "/Upload",
  "Upload": "/Upload",
  "Review": "/Review",
  "Submit": "/Submit",
  "Payment": "/Payment",
};

export const steps = [
  {
    name: "KYC Verification",
    redirectTo: ["/KYCVerification"],
    nestedSteps: ["KYC Verification"],
  },
  {
    name: "Personal Details",
    redirectTo: ["/Profile", "/AddressDetails", "/NomineeDetails"],
    nestedSteps: ["Profile", "Address Details", "Nominee Details"],
  },
  {
    name: "Bank Details",
    redirectTo: ["/BankDetails", "/PlanDetails", "/Payment"],
    nestedSteps: ["Bank Details", "Plan Details", "Payment"],
  },
  {
    name: "Upload & Submit",
    redirectTo: ["/Upload", "/Review", "/Submit"],
    nestedSteps: ["Upload", "Review", "Submit"],
  },
];

export const appStages = [
  { "kycstageId": 1, "stageName": "Address Details", "stageCode": "ADD", "loginId": null, "status": 0 },
  { "kycstageId": 2, "stageName": "Basic Details", "stageCode": "BASIC", "loginId": null, "status": 0 },
  { "kycstageId": 3, "stageName": "Form Proof Details", "stageCode": "FORM", "loginId": null, "status": 0 },
  { "kycstageId": 4, "stageName": "Nominee", "stageCode": "NOMM", "loginId": null, "status": 0 },
  { "kycstageId": 5, "stageName": "Bank Details", "stageCode": "BANK", "loginId": null, "status": 0 },
  { "kycstageId": 6, "stageName": "Brokerage Details", "stageCode": "BROK", "loginId": null, "status": 0 },
  { "kycstageId": 7, "stageName": "Personal Details", "stageCode": "PERSO", "loginId": null, "status": 0 },
  { "kycstageId": 8, "stageName": "Pan Details", "stageCode": "PAN", "loginId": null, "status": 0 },
  { "kycstageId": 9, "stageName": "Payment Details", "stageCode": "PAY", "loginId": null, "status": 0 },
  { "kycstageId": 10, "stageName": "Client Esign", "stageCode": "ESIGN", "loginId": null, "status": 0 },
  { "kycstageId": 11, "stageName": "Under Scrutiny", "stageCode": "SCRUT", "loginId": null, "status": 0 },
  { "kycstageId": 12, "stageName": "Objection Details", "stageCode": "OBJEC", "loginId": null, "status": 0 }
]

export function detailChecker(appStageData, currentStage) {
  // appStageData = JSON.parse(localStorage.getItem("appStages"))
  if (appStageData && appStageData[currentStage])
    return appStageData[currentStage].status == 1
  else
    return false
} 

let completedStepsStepper = {
  // "PAN": { step: 0, nestedStep: 0 },
  "PERSO": { setDirectly : true, stepper : [1, 1] },
  "ADD": { setDirectly : true, stepper : [1, 2] },
  "BASIC": { setDirectly : true, stepper : [1, 2] },
  "NOMM": { setDirectly : true, stepper : [1, 3] },
  "BANK": { setDirectly : true, stepper : [1, 3, 1] },
  "BROK": { setDirectly : true, stepper : [1, 3, 2] },
  "PAY":{ setDirectly : true, stepper : [1, 3, 3] },
  "FORM": { setDirectly : true, stepper : [1, 3, 3, 1] },
  "ESIGN": { setDirectly : true, stepper : [1, 3, 3, 3] },
}

export function getGlobalSteper(appStageData){
  let globalStepper = {}
  Object.keys(completedStepsStepper).forEach(step=>{
    let currentStage = appStageData.find(stageStep=> stageStep.stageCode == step);
    if(currentStage?.status == 1){
      globalStepper = completedStepsStepper[step]
    }
  })
  return globalStepper
}